'use client';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import React from 'react';

const AppFooter = () => {
  return (
    <div className="position-relative mx-auto py-2">
      <div className={cn('p-2 text-center text-sm')}>
        SmartGuy® - All rights reserved |
        <Link
          href="/pages/terms-of-use"
          target="_blank"
          className="mx-1 underline hover:text-gray-700"
        >
          Terms of use
        </Link>
        -
        <Link
          href="/pages/privacy-policy"
          target="_blank"
          className="mx-1 underline hover:text-gray-700"
        >
          Privacy Policy
        </Link>
        {/* -
        <Link
          href="/sitemap.xml"
          target="_blank"
          rel="noopener noreferrer"
          className="mx-1 underline hover:text-gray-700"
        >
          Sitemap
        </Link> */}
        -
        <Link href="/videos" className="mx-1 underline hover:text-gray-700">
          SmartGuy Videos
        </Link>
        -
        <Link href="/blogs" className="mx-1 underline hover:text-gray-700">
          Blogs
        </Link>
        -
        <Link href="/community" className="mx-1 underline hover:text-gray-700">
          Community
        </Link>
      </div>
    </div>
  );
};

export default AppFooter;
